/* ==========================================================================
   Personal Training — booking form.

   One job: keep the total on screen in step with the number of hours, so the
   visitor sees what the checkout is going to charge before they get there.

   The figure is a preview only. Shopify prices the line itself from the
   variant and the quantity, so the two can never disagree — and if this script
   never runs, the form still works and still adds the right number of hours.
   ========================================================================== */
(function () {
  'use strict';

  function money(cents, currency) {
    var amount = cents / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'EUR'
      }).format(amount);
    } catch (e) {
      /* An unknown currency code should never cost the visitor the total. */
      return amount.toFixed(2);
    }
  }

  function Booking(form) {
    var hours = form.querySelector('[data-pt-hours]');
    var total = form.querySelector('[data-pt-total]');
    var sum = form.querySelector('[data-pt-sum]');
    var date = form.querySelector('[data-pt-date]');
    if (!hours || !total) return null;

    var unit = parseInt(form.getAttribute('data-unit-price'), 10);
    var currency = form.getAttribute('data-currency') || 'EUR';
    if (!isFinite(unit)) return null;

    var max = parseInt(hours.getAttribute('max'), 10) || 12;
    var min = parseInt(hours.getAttribute('min'), 10) || 1;

    function update() {
      var n = parseInt(hours.value, 10);
      if (!isFinite(n)) n = min;
      if (n < min) n = min;
      if (n > max) n = max;
      if (String(n) !== hours.value) hours.value = n;

      total.textContent = money(unit * n, currency);
      if (sum) sum.textContent = money(unit, currency) + ' × ' + n;
    }

    hours.addEventListener('input', update);
    hours.addEventListener('change', update);

    /* Nobody can train yesterday. */
    if (date && !date.getAttribute('min')) {
      var d = new Date();
      var iso = d.getFullYear() + '-' +
        String(d.getMonth() + 1).padStart(2, '0') + '-' +
        String(d.getDate()).padStart(2, '0');
      date.setAttribute('min', iso);
    }

    update();
    return { destroy: function () {
      hours.removeEventListener('input', update);
      hours.removeEventListener('change', update);
    } };
  }

  var instances = [];

  function initAll() {
    instances = instances.filter(function (e) {
      if (document.contains(e.root)) return true;
      if (e.api && e.api.destroy) e.api.destroy();
      return false;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-pt-booking]'), function (form) {
      if (form.getAttribute('data-pt-init') === 'true') return;
      form.setAttribute('data-pt-init', 'true');
      var api = Booking(form);
      if (api) instances.push({ root: form, api: api });
    });
  }

  if (window.JaduzarBooking && window.JaduzarBooking.initAll) {
    window.JaduzarBooking.initAll();
    return;
  }
  window.JaduzarBooking = { initAll: initAll };

  document.addEventListener('shopify:section:load', function (e) {
    var t = e && e.target;
    if (t && t.querySelector && t.querySelector('[data-pt-booking]')) initAll();
  });
  document.addEventListener('shopify:section:unload', function () { initAll(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
